module.exports = __webpack_public_path__ + "static/media/mind-map.36ef0fab.svg";